// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { BilancioRigheDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class BilancioRigheApiClient extends BaseCRUDApiClient<BilancioRigheDto> {
  baseUrl = this.config.apiEndpoint + '/bilancio-righe';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  compilaBilancioRighe() {
    return this.http.get(`${this.baseUrl}/compila-bilancio-righe`);
  }
}
